// React
import React from "react";
import {isMobile} from "react-device-detect";

//Components
import RegressionV2 from "./components/Diagram/regression";

const App = () => {
    return (
      <div className={'App ' + (isMobile ? 'isMobile' : '')}>
            <RegressionV2/>
        </div>
    );
}

export default App;
